import ZapIcon from "@uui/Zap";

import IconHeading from "@app/analytics/components/IconHeading";
import useTopicReport from "@app/analytics/TopicReport/hooks/useTopicReport";
import useTopicReportEntities from "@app/analytics/TopicReport/hooks/useTopicReportEntities";

import IconBackground from "@rui/IconBackground";
import { Link } from "@rui/Link";
import { Row } from "@rui/Stack";
import { Bold, Span } from "@rui/styles";

import { Card, SummaryText } from "./styles";

const scrollToTimeline = () => {
  const timelineHeading = document.querySelector('[data-scroll-id="timeline"]');
  timelineHeading?.scrollIntoView({ behavior: "smooth", block: "start" });
};

const LatestUpdate = () => {
  const { isSharedReport } = useTopicReport();
  const { latestUpdate } = useTopicReportEntities();

  if (!latestUpdate) return null;

  return (
    <Card sx={{ borderColor: "shades.primary.500" }} spacing={1}>
      <Row variant="left" spacing={1}>
        <IconHeading
          startIcon={
            <IconBackground
              height={20}
              sx={{ background: (theme) => theme.palette.gradients.read }}
            >
              <ZapIcon sx={{ color: "#FFF" }} />
            </IconBackground>
          }
        >
          Latest Update
        </IconHeading>
        {!isSharedReport && (
          <Link
            variant="bodySecondaryReg"
            onClick={scrollToTimeline}
            sx={{ fontFamily: (theme) => theme.typography.fontFamilySecondary }}
          >
            All updates
          </Link>
        )}
      </Row>
      <SummaryText className="loose">
        <Bold>
          {latestUpdate.createdOn.toLocaleString({
            month: "short",
            day: "numeric",
            year: "numeric",
          })}
          :
        </Bold>
        <Span sx={{ color: "shades.neutral.700" }}> {latestUpdate.text}</Span>
      </SummaryText>
    </Card>
  );
};

export default LatestUpdate;
